const pressures = {
  4: 'Low',
  5: 'Very Low',
  7: 'High',
  8: 'Very High',
  9: 'Very Low',
};

export default pressures;
